import React, { useState } from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Popover, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { toast } from 'react-toastify';
import expcancel from "../../../assests/expcancel.svg"
import successicon from "../../../assests/activeRule.svg"
import './productExpiryListDetails.css';
import LoadingSpinner from '../../Loading/component';
import datetimepreview from "../../../assests/datetimepreview.svg"
import expiredicon from "../../../assests/expiredicon.svg"
import vmifoicon from "../../../assests/cohorts.svg"
import productinfo from "../../../assests/productinfo.svg"
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';

// Helper function to format large numbers
const formatLargeNumber = (num) => {
  const n = Number(num);
  if (isNaN(n)) return '0';
  
  if (n > 1000000) {
    return (n / 1000000).toFixed(1) + 'M';
  } else if (n > 1000) {
    return (n / 1000).toFixed(1) + 'K';
  }
  return n.toString();
};

// CalendarDialog (unchanged)
const CalendarDialog = ({ open, onClose, onSchedule }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedHour, setSelectedHour] = useState('10');
  const [selectedMinute, setSelectedMinute] = useState('00');
  const [timePeriod, setTimePeriod] = useState('AM');
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const today = new Date(); today.setHours(0, 0, 0, 0);

  const isPastDate = (date, isCurrentMonth, month, year) => {
    if (!isCurrentMonth) return false;
    const testDate = new Date(year, month, date); testDate.setHours(0, 0, 0, 0);
    return testDate < today;
  };
  const isToday = (date, isCurrentMonth, month, year) => {
    if (!isCurrentMonth) return false;
    const testDate = new Date(year, month, date); testDate.setHours(0, 0, 0, 0);
    return testDate.getTime() === today.getTime();
  };
  const isSelectableDate = (date, isCurrentMonth, month, year) => isCurrentMonth && !isPastDate(date, isCurrentMonth, month, year);

  const generateCalendar = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate();
    const days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    const dates = [];
    let week = [];

    for (let i = 0; i < firstDay; i++) {
      week.push({
        date: daysInPrevMonth - firstDay + i + 1,
        isCurrentMonth: false,
        month: month - 1 < 0 ? 11 : month - 1,
        year: month - 1 < 0 ? year - 1 : year
      });
    }
    for (let i = 1; i <= daysInMonth; i++) {
      week.push({ date: i, isCurrentMonth: true, month, year });
      if (week.length === 7) { dates.push([...week]); week = []; }
    }
    let nextMonthDay = 1;
    while (week.length > 0 && week.length < 7) {
      week.push({
        date: nextMonthDay++,
        isCurrentMonth: false,
        month: month + 1 > 11 ? 0 : month + 1,
        year: month + 1 > 11 ? year + 1 : year
      });
    }
    if (week.length > 0) dates.push(week);
    return { days, dates, month, year };
  };

  const { days, dates } = generateCalendar();

  const handleDateSelect = (date, isCurrentMonth, month, year) => {
    if (!isSelectableDate(date, isCurrentMonth, month, year)) return;
    setSelectedDate(new Date(year, month, date));
  };
  const handleMonthChange = (dir) => {
    const nm = new Date(currentMonth);
    nm.setMonth(currentMonth.getMonth() + dir);
    setCurrentMonth(nm);
  };

  const handleSchedule = () => {
    let hour = parseInt(selectedHour);
    if (timePeriod === 'PM' && hour < 12) hour += 12;
    if (timePeriod === 'AM' && hour === 12) hour = 0;
    const formattedDate = `${selectedDate.getDate().toString().padStart(2, '0')} ${selectedDate.toLocaleString('default', { month: 'short' })} ${selectedDate.getFullYear()}, ${hour.toString().padStart(2, '0')}:${selectedMinute} ${timePeriod}`;
    const timestamp = `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')} ${hour.toString().padStart(2, '0')}:${selectedMinute}:00`;
    onSchedule(formattedDate, timestamp);
    onClose();
  };

  const isSelected = (date, isCurrentMonth, month, year) => {
    if (!isCurrentMonth) return false;
    return selectedDate.getDate() === date && selectedDate.getMonth() === month && selectedDate.getFullYear() === year;
  };

  const hourOptions = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  const minuteOptions = ['00', '15', '30', '45'];

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: "center", flexDirection: "column" }}>
          <img src={datetimepreview} alt="" style={{ width: 58, height: 58 }} />
          <Typography style={{ fontSize: "16px", fontWeight: 600 }}>Schedule Expiry</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="calendar-dialog">
          <div className="calendar-header">
            <button onClick={() => handleMonthChange(-1)}>&lt;</button>
            <span>{currentMonth.toLocaleString('default', { month: 'long' })} {currentMonth.getFullYear()}</span>
            <button onClick={() => handleMonthChange(1)}>&gt;</button>
          </div>

          <div className="calendar-grid">
            {days.map((d, i) => (<div key={i} className="calendar-day-header">{d}</div>))}
            {dates.flat().map(({ date, isCurrentMonth, month, year }, idx) => {
              const selectable = isSelectableDate(date, isCurrentMonth, month, year);
              const pastDate = isPastDate(date, isCurrentMonth, month, year);
              const today = isToday(date, isCurrentMonth, month, year);
              return (
                <div
                  key={idx}
                  className={[
                    'calendar-date',
                    isCurrentMonth ? 'current-month' : 'other-month',
                    isSelected(date, isCurrentMonth, month, year) ? 'selected' : '',
                    pastDate ? 'past-date' : '',
                    today ? 'today' : '',
                    selectable ? 'selectable' : 'not-selectable'
                  ].join(' ')}
                  onClick={() => handleDateSelect(date, isCurrentMonth, month, year)}
                >
                  {date}
                  {today && <div className="today-indicator" />}
                </div>
              );
            })}
          </div>

          <div className="time-selection">

            <div className="time-controls">
              <div className="time-control-group">
                <label>Hour</label>
                <select value={selectedHour} onChange={(e) => setSelectedHour(e.target.value)} className="time-select">
                  {hourOptions.map(h => <option key={h} value={h}>{h}</option>)}
                </select>
              </div>
              <div className="time-control-group">
                <label>Minute</label>
                <select value={selectedMinute} onChange={(e) => setSelectedMinute(e.target.value)} className="time-select">
                  {minuteOptions.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
              <div className="time-control-group">
                <label>AM/PM</label>
                <select value={timePeriod} onChange={(e) => setTimePeriod(e.target.value)} className="period-select">
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </div>
            </div>
            <div className="selected-date-preview">
              {selectedDate.getDate().toString().padStart(2, '0')} {selectedDate.toLocaleString('default', { month: 'short' })} {selectedDate.getFullYear()}, {selectedHour}:{selectedMinute} {timePeriod}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions className='action-btn'>
        <Button onClick={onClose} className="exp-cancel-btn">Cancel</Button>
        <Button onClick={handleSchedule} className="exp-schedule-btn">Schedule</Button>
      </DialogActions>
    </Dialog>
  );
};

// ExpireNowDialog
const ExpireNowDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} maxWidth="sm" fullWidth style={{ width: "450px", margin: "auto" }}>
    <DialogTitle>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: "center" }}>
        <img src={expiredicon} alt="" style={{ width: 58, height: 58 }} />
      </div>
    </DialogTitle>
    <DialogContent>
      <div className="cancel-dialog-exp">
        <p>Are you sure you want to <br /> mark this product as expire ?</p>
      </div>
    </DialogContent>
    <DialogActions className='action-btn'>
      <Button onClick={onClose} className="product-expiry-cancel-btn">No</Button>
      <Button onClick={onConfirm} className="exp-done-btn">Yes</Button>
    </DialogActions>
  </Dialog>
);

// CancelDialog
const CancelDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} maxWidth="sm" fullWidth style={{ width: "450px", margin: "auto" }}>
    <DialogTitle>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: "center" }}>
        <img src={expcancel} alt="" style={{ width: 48, height: 48 }} />
      </div>
    </DialogTitle>
    <DialogContent>
      <div className="cancel-dialog-exp">
        <p>Are You Sure You Want To <br /> Cancel The Scheduled Expiry?</p>
      </div>
    </DialogContent>
    <DialogActions style={{ justifyContent: "space-between" }}>
      <Button onClick={onClose} className="cancel-btn-no">No</Button>
      <Button onClick={onConfirm} className="product-expire-cancel-btn">Yes, Cancel</Button>
    </DialogActions>
  </Dialog>
);

// SuccessDialog
const SuccessDialog = ({ open, onClose, expiryDate, isScheduled = false, isExpiry = false, isCancelled = false }) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth style={{ width: "450px", margin: "auto" }}>
      <DialogContent className="success-dialog-card">
        <div className="success-top">
          <div className="success-icon"><img src={successicon} alt="" /></div>
        </div>

        <div className="success-body">
          <h3 className="success-title">
            {isCancelled
              ? 'Expiry Cancelled'
              : isExpiry
                ? 'Successfully Expired'
                : isScheduled
                  ? 'Successfully Scheduled'
                  : 'Success'}
          </h3>

          {isCancelled ? (
            <p className="success-text">Scheduled expiry has been successfully cancelled.</p>
          ) : isExpiry ? (
            <p className="success-text">Product has been successfully expired.</p>
          ) : isScheduled ? (
            <>
              <p className="success-text">Product will no longer be available after</p>
              <div className="expiry-date">{expiryDate}</div>
              <p className="success-text small">It will remain active across all VMs/Slot until then</p>
            </>
          ) : null}
        </div>

        <div className="success-actions">
          <Button onClick={onClose} className="exp-done-btn">Done</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const Product_Expiry_List_Component = ({
  productListDetailsData,
  loading,
  error,
  navigate,
  formatCurrency,
  onExpireNow,
  onExpireLater,
  handleCancelProduct
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [expireNowOpen, setExpireNowOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [scheduledDate, setScheduledDate] = useState('');
  const [isScheduled, setIsScheduled] = useState(false);
  const [isExpiry, setIsExpiry] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [statusFilter, setStatusFilter] = useState('active'); // Default to active
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const productDetails = productListDetailsData?.productDetails || {};
  const vmListings = productListDetailsData?.vmList || [];

  // Filter VM listings based on search term AND status filter
  const filteredVmListings = vmListings.filter(vm =>
    (vm.vending_machine_id?.toString().includes(searchTerm) ||
    vm.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vm.slot_identifier?.toString().includes(searchTerm)) &&
    (statusFilter === 'all' || vm.status?.toLowerCase() === statusFilter)
  );

  // Get status counts
  const getStatusCounts = () => {
    const counts = { active: 0, scheduled: 0, expired: 0 };
    vmListings.forEach(vm => {
      if (vm.status && counts.hasOwnProperty(vm.status.toLowerCase())) {
        counts[vm.status.toLowerCase()]++;
      }
    });
    return counts;
  };

  const statusCounts = getStatusCounts();
  
  // Fixed calculations with safe number parsing - using active_count and hold_count
  const totalActive = vmListings.reduce((sum, vm) => {
    const activeCount = vm.active_count || 0;
    return sum + (isNaN(Number(activeCount)) ? 0 : Number(activeCount));
  }, 0);

  const totalHold = vmListings.reduce((sum, vm) => {
    const holdCount = vm.hold_count || 0;
    return sum + (isNaN(Number(holdCount)) ? 0 : Number(holdCount));
  }, 0);

  const totalCount = totalActive + totalHold;

  // Get items by status
  const getItemsByStatus = (status) => {
    return filteredVmListings
      .filter(vm => vm.status === status && vm.vending_machine_id && vm.slot_identifier)
      .map(vm => `${vm.vending_machine_id}-${vm.slot_identifier}`);
  };

  // Updated hasZeroActiveCount function - using active_count instead of active_quantity
  const hasZeroActiveCount = (vm) => {
    const activeCount = vm.active_count || 0;
    return Number(activeCount) === 0;
  };

  // Helper function to safely parse numbers for display
  const safeParseNumber = (num) => {
    const parsed = Number(num);
    return isNaN(parsed) ? 0 : parsed;
  };

  // Check if all selectable items of selectedStatus are selected
  const isAllSelected = selectedStatus && filteredVmListings
    .filter(vm => vm.status === selectedStatus && !hasZeroActiveCount(vm))
    .every(vm => selectedItems.includes(`${vm.vending_machine_id}-${vm.slot_identifier}`));

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      let targetStatus = selectedStatus;
      if (!targetStatus) {
        if (filteredVmListings.some(vm => vm.status === 'active' && !hasZeroActiveCount(vm))) {
          targetStatus = 'active';
        } else if (filteredVmListings.some(vm => vm.status === 'scheduled' && !hasZeroActiveCount(vm))) {
          targetStatus = 'scheduled';
        }
      }
      if (targetStatus) {
        const itemsToSelect = filteredVmListings
          .filter(vm => vm.status === targetStatus && !hasZeroActiveCount(vm))
          .map(vm => `${vm.vending_machine_id}-${vm.slot_identifier}`);
        setSelectedItems(itemsToSelect);
        setSelectedStatus(targetStatus);
      }
    } else {
      // ❌ Clear sab selection
      setSelectedItems([]);
      setSelectedStatus(null);
    }
  };

  // ✅ handle select item
  const handleSelectItem = (combinationId, itemStatus, vm) => {
    if (itemStatus === 'expired') {
      toast.error("Expired items cannot be selected");
      return;
    }
    if (hasZeroActiveCount(vm)) {
      toast.error("Items with zero active count cannot be selected");
      return;
    }
    if (selectedStatus && itemStatus !== selectedStatus) {
      toast.error(`Cannot select ${itemStatus} items together with ${selectedStatus} items`);
      return;
    }
    let newSelected = [...selectedItems];
    if (newSelected.includes(combinationId)) {
      newSelected = newSelected.filter(id => id !== combinationId);
      if (newSelected.length === 0) setSelectedStatus(null);
    } else {
      newSelected.push(combinationId);
      if (!selectedStatus) setSelectedStatus(itemStatus);
    }
    setSelectedItems(newSelected);
  };

  // NEW: Check if main checkbox should be disabled
  const isMainCheckboxDisabled = () => {
    const selectable = filteredVmListings.filter(vm =>
      vm.status !== 'expired' && !hasZeroActiveCount(vm)
    );
    return selectable.length === 0;
  };

  const isCheckboxDisabled = (itemStatus, vm) => {
    if (itemStatus === 'expired') return true;
    if (hasZeroActiveCount(vm)) return true;
    if (!selectedStatus) return false;
    return itemStatus !== selectedStatus;
  };
  const hasScheduledItems = selectedStatus === 'scheduled';
  const hasActiveItems = selectedStatus === 'active';

  const handleExpireNowClick = () => setExpireNowOpen(true);

  const confirmExpireNow = () => {
    setExpireNowOpen(false);
    if (selectedItems.length === 0) {
      toast.error("Select items first");
      return;
    }

    const vmIds = selectedItems.map(comb => parseInt(comb.split('-')[0]));
    onExpireNow(vmIds, () => {
      setScheduledDate('');
      setIsScheduled(false);
      setIsExpiry(true);
      setSuccessOpen(true);
      setSelectedItems([]);
      setSelectedStatus(null);
    });
  };

  const handleExpireLater = () => setCalendarOpen(true);

  const handleScheduleExpiry = (formattedDate, timestamp) => {
    if (selectedItems.length === 0) {
      toast.error("Select items first");
      return;
    }

    const vmIds = selectedItems.map(comb => parseInt(comb.split('-')[0]));
    onExpireLater(vmIds, timestamp, () => {
      setScheduledDate(formattedDate);
      setIsScheduled(true);
      setIsExpiry(false);
      setSuccessOpen(true);
      setSelectedItems([]);
      setSelectedStatus(null);
    });
    setCalendarOpen(false);
  };

  const handleCancelClick = () => setCancelOpen(true);

  const confirmCancel = () => {
    setCancelOpen(false);
    if (selectedItems.length === 0) {
      toast.error("No items selected for cancellation");
      return;
    }
    const vmIds = selectedItems.map(comb => parseInt(comb.split('-')[0]));
    handleCancelProduct(vmIds, () => {
      setSelectedItems([]);
      setSelectedStatus(null);
      setIsCancelled(true);
      setIsScheduled(false);
      setIsExpiry(false);
      setSuccessOpen(true);
    });
  };

  const getStatusColor = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'active': return '#0AA36D';
      case 'scheduled': return '#FF9800';
      case 'expired': return '#E02D3C';
      default: return '#757575';
    }
  };

  const getStatusBgColor = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'active': return 'rgba(10,163,109,0.12)';
      case 'scheduled': return 'rgba(255,152,0,0.12)';
      case 'expired': return 'rgba(224,45,60,0.08)';
      default: return '#f5f5f5';
    }
  };

  // Status filter handlers
  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
  };

  const clearStatusFilter = () => {
    setStatusFilter('active'); // Reset to default active
    handleFilterClose();
  };

  const openFilter = Boolean(filterAnchorEl);
  const filterId = openFilter ? 'status-filter-popover' : undefined;

  return (
    <div className="product-expiry-details-container">
      {loading && (
        <div>
          <LoadingSpinner />
        </div>
      )}
      <Sidebar />
      <div className="product-expiry-details-content">
        <div className="product-details-header">
          <Button className="back-button" onClick={() => navigate(-1)} aria-label="Go back">
            <img src={leftArrow} alt="Back" />
          </Button>
          <h1>Product Details</h1>
        </div>

        <div className="product-info-card">
          <div className="product-info-header">
            <img src={productinfo} alt="" />
            <h3 className="product-info-title">Info</h3>
          </div>

          <div className="product-info-grid">
            <div className="product-info-block image-block">
              <div className="product-image-container">
                {productDetails.image_id ? (
                  <img
                    src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${productDetails.image_id}`}
                    alt={productDetails.variant_name || "Product"}
                    className="product-main-image"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                ) : null}
                <div
                  className="product-image-placeholder"
                  style={{ display: productDetails.image_id ? "none" : "flex" }}
                >
                  No Image
                </div>
              </div>
            </div>

            <div className="product-info-block details-block">
              <div className="product-detail-item">
                <span className="product-detail-label">Product Name:</span>
                <span className="product-detail-value">
                  {productDetails.variant_name || "N/A"}
                </span>
              </div>
              <div className="product-detail-item">
                <span className="product-detail-label">MVID:</span>
                <span className="product-detail-value">
                  {productDetails.id || "N/A"}
                </span>
              </div>
              <div className="product-detail-item">
                <span className="product-detail-label">Vendor:</span>
                <span className="product-detail-value">
                  {productDetails.manufacturer_name || "N/A"}
                </span>
              </div>
              <div className="product-detail-item">
                <span className="product-detail-label">Offer Price:</span>
                <span className="product-detail-value">
                  {formatCurrency(productDetails.offer_price)}
                </span>
              </div>
            </div>

            <div className="product-info-block meal-block">
              <div className="product-detail-item">
                <span className="product-detail-label">Meal Type:</span>
                <span className="product-detail-value">
                  {productDetails.meal_type || "N/A"}
                </span>
              </div>
              <div className="product-detail-item">
                <span className="product-detail-label">Total Count:</span>
                <span className="product-detail-value">
                  {formatLargeNumber(totalCount)} (Including Duplicate Slots)
                </span>
              </div>
              {/* <div className="product-detail-item">
                <span className="product-detail-label">Active Count:</span>
                <span className="product-detail-value">
                  {formatLargeNumber(totalActive)}
                </span>
              </div>
              <div className="product-detail-item">
                <span className="product-detail-label">Hold Count:</span>
                <span className="product-detail-value">
                  {formatLargeNumber(totalHold)}
                </span>
              </div> */}
            </div>
          </div>
        </div>

        <div className="vm-listing-card">
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", gap: "4px" }}>
            <img src={vmifoicon} alt="" />
            <h3 className="vm-listing-title">VM Listing For Product</h3>
          </div>

          <div className="vm-search-container">
            <input
              type="text"
              placeholder="Search By VMID, Name, or Slot"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="vm-search-input"
            />
          </div>

          <div className="vm-exp-table-container">
            <table className="vm-listing-table">
              <thead>
                <tr>
                  <th className="vm-checkbox-cell">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                      disabled={isMainCheckboxDisabled()}
                      title={isMainCheckboxDisabled() ? "No selectable items available" : "Select all items of current status"}
                    />
                  </th>
                  <th>V.M ID</th>
                  <th>V.M Address</th>
                  <th>VM Slot</th>
                  <th>Active</th>
                  <th>Hold</th>
                  <th>Total Count</th>
                  <th>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      Status
                      <IconButton 
                        size="small" 
                        onClick={handleFilterClick}
                        style={{ 
                          padding: '2px',
                          color: statusFilter !== 'active' ? '#1976d2' : 'inherit'
                        }}
                      >
                        <FilterListIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </th>
                  <th>VM Image</th>
                </tr>
              </thead>
              <tbody>
                {filteredVmListings.length > 0 ? filteredVmListings.map((vm, index) => {
                  const combinationId = `${vm.vending_machine_id}-${vm.slot_identifier}`;
                  const isSelected = selectedItems.includes(combinationId);
                  const isDisabled = isCheckboxDisabled(vm.status, vm);
                  // Use active_count and hold_count for display
                  const activeCount = safeParseNumber(vm.active_count);
                  const holdCount = safeParseNumber(vm.hold_count);
                  const totalRowCount = activeCount + holdCount;

                  return (
                    <tr key={combinationId || index} style={{ backgroundColor: getStatusBgColor(vm.status) }}>
                      <td className="vm-checkbox-cell">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handleSelectItem(combinationId, vm.status, vm)}
                          disabled={isDisabled}
                          title={isDisabled ?
                            (vm.status === 'expired' ? "Expired items cannot be selected" :
                              hasZeroActiveCount(vm) ? "Items with zero active count cannot be selected" :
                                `Cannot select ${vm.status} with ${selectedStatus || 'other'} items`)
                            : `Select all ${vm.status} items`}
                        />
                      </td>
                      <td>{vm.vending_machine_id || 'N/A'}</td>
                      <td>{vm.name || 'N/A'}</td>
                      <td>{vm.slot_identifier || 'N/A'}</td>
                      <td className={hasZeroActiveCount(vm) ? 'zero-count' : ''}>
                        {formatLargeNumber(activeCount)}
                      </td>
                      <td>{formatLargeNumber(holdCount)}</td>
                      <td>{formatLargeNumber(totalRowCount)}</td>
                      <td>
                        <span className="status-badge-exp" style={{
                          color: getStatusColor(vm.status),
                          backgroundColor: getStatusBgColor(vm.status)
                        }}>
                          {vm.status || 'Unknown'}
                        </span>
                      </td>
                      <td>
                        {vm.image_id ? (
                          <img
                            src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${vm.image_id}`}
                            alt="VM"
                            className="vm-image"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        ) : 'N/A'}
                      </td>
                    </tr>
                  );
                }) : (
                  <tr><td colSpan="9" className="no-data">No VM listings found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Status Filter Popover */}
        <Popover
          id={filterId}
          open={openFilter}
          anchorEl={filterAnchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              padding: '15px',
              minWidth: '200px',
            }
          }}
        >
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ fontWeight: 'bold' }}>Filter by Status</div>
            <IconButton 
              size="small" 
              onClick={handleFilterClose}
              style={{ padding: '2px' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          {/* Clickable Filter List */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {['active', 'scheduled', 'expired'].map((status) => (
              <div
                key={status}
                onClick={() => {
                  handleStatusFilterChange(status);
                  handleFilterClose();
                }}
                style={{
                  padding: '8px 10px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  backgroundColor: statusFilter === status ? '#FFEEE0' : '#f9f9f9',
                  color: statusFilter === status ? '#FF7A00' : '#333',
                  fontWeight: statusFilter === status ? '600' : '400',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFF4E6'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = statusFilter === status ? '#FFEEE0' : '#f9f9f9'}
              >
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </div>
            ))}
          </div>

          {/* Reset Button */}
          <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              onClick={clearStatusFilter}
              variant="outlined" 
              size="small"
              disabled={!statusFilter}
            >
              Reset
            </Button>
          </div>
        </Popover>

        {selectedItems.length > 0 && (
          <div className="status-summary-container">
            {hasScheduledItems ? (
              <div className="status-item">
                <Button variant='contained' className="product-expire-cancel-btn" onClick={handleCancelClick}>
                  Cancel Expiry ({selectedItems.length})
                </Button>
              </div>
            ) : hasActiveItems ? (
              <>
                <div className="status-item">
                  <Button variant='outlined' className="expire-later-btn" onClick={handleExpireLater}>
                    Expire Later ({selectedItems.length})
                  </Button>
                </div>
                <div className="status-item">
                  <Button variant='contained' className="expire-now-btn" onClick={handleExpireNowClick}>
                    Expire Now ({selectedItems.length})
                  </Button>
                </div>
              </>
            ) : null}
          </div>
        )}

        <CalendarDialog open={calendarOpen} onClose={() => setCalendarOpen(false)} onSchedule={handleScheduleExpiry} />
        <ExpireNowDialog open={expireNowOpen} onClose={() => setExpireNowOpen(false)} onConfirm={confirmExpireNow} />
        <CancelDialog open={cancelOpen} onClose={() => setCancelOpen(false)} onConfirm={confirmCancel} />

        <SuccessDialog
          open={successOpen}
          onClose={() => setSuccessOpen(false)}
          expiryDate={scheduledDate}
          isScheduled={isScheduled}
          isExpiry={isExpiry}
          isCancelled={isCancelled}
        />
      </div>
    </div>
  );
};

export default Product_Expiry_List_Component;